<template>
  <li v-if="navPlacement === 'sidebar'" class="nav-item">
    <a
      href="#"
      class="nav-link"
      :data-tab-id="tabKey"
      :class="{ active: tabKey === currentTab }"
      data-toggle="collapse"
      @click.prevent="setCurrentTab(tabKey)"
      ref="tabLink"
    >
      <span
        v-if="tab.icon"
        class="nav-item__icon"
        :style="`color: ${tab.icon.color}`"
      >
        <icon :name="tab.icon.name" />
      </span>
      <span v-else class="nav-item__icon _placeholder">
        <icon name="circle" />
      </span>
      <span class="nav-link-text" @click="hideLessDesktop">{{
        tab.title
      }}</span>
      <span
        v-if="isAdmin && !tab.inherited && currentTab === tabKey"
        class="sidenav__menuTrigger sidenav__editTabTrigger"
        @click.prevent.stop="showTabContextMenu($event)"
      >
        <icon name="ellipsis-v" style="vertical-align: -4px;" />
      </span>
      <a
        href="#"
        class="nav-link__subTabToggle"
        v-if="subTabs[tabKey]"
        @click.prevent.stop="toggleSidebarItemSubTabs(tabKey)"
      >
        <icon
          name="chevron-right"
          scale=".7"
          class="nav-link__expandIcon _collapsed"
        />
        <icon
          name="chevron-down"
          scale=".7"
          class="nav-link__expandIcon _expanded"
        />
      </a>
    </a>
    <div v-if="subTabs[tabKey]" class="collapse" ref="subTabs">
      <ul class="nav nav-sm flex-column">
        <li
          v-for="(subTab, subTabKey) in subTabs[tabKey]"
          :key="subTabKey"
          class="nav-item"
        >
          <a
            href="#"
            class="nav-link"
            :class="{ active: currentSubTab === subTabKey }"
            @click.prevent="setCurrentSubTab(subTabKey, tabKey)"
          >
            <span
              v-if="isAdmin && !subTab.inherited && subTabKey === currentSubTab"
              class="sidenav__menuTrigger sidenav__editSubTabTrigger"
              @click.prevent.stop="showSubTabContextMenu($event)"
            >
              <icon
                name="ellipsis-v"
                style="vertical-align: -2px;"
                scale=".8"
              />
            </span>
            <span @click="hideLessDesktop">{{ subTab.title }}</span>
          </a>
        </li>
        <li class="nav-item">
          <a href="#" class="nav-link" @click.prevent="addNewSubTab(tabKey)">
            <i class="ni ni-fat-add text-white"></i>
            <span style="padding-top: 3px;">Add Sub Page</span>
          </a>
        </li>
      </ul>
    </div>
  </li>
  <li v-else></li>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ['navPlacement', 'tab', 'subTabs', 'tabKey'],
  computed: {
    ...mapState(['currentTab', 'currentSubTab', 'currentDash']),
    isAdmin() {
      return this.$can('update', 'Dashboard_' + this.currentDash)
    },
  },
  watch: {
    currentTab(value) {
      if (this.tabKey !== value && !this.tab.expandedByDefault) {
        $(this.$refs.tabLink).attr('aria-expanded', false)

        if (this.$refs.subTabs) {
          $(this.$refs.subTabs).removeClass('show')
        }
      }
    },
  },
  methods: {
    hideLessDesktop() {
      if (this.$sidebar.breakpoint > window.innerWidth) {
        this.$sidebar.toggleMinimize()
      }
    },
    toggleSidebarItemSubTabs(tabKey) {
      let state = $(`[data-tab-id="${tabKey}"]`).attr('aria-expanded')
      state = state === 'true' ? false : true

      $(`[data-tab-id="${tabKey}"]`).attr('aria-expanded', state)

      $(`[data-tab-id="${tabKey}"] + div`).toggleClass('show')
    },
    setCurrentTab(tabKey) {
      $setCurrentTab(tabKey)

      if (this.subTabs[tabKey]) this.expandSubTabs()
    },
    showTabContextMenu(event) {
      this.$emit('showTabContextMenu', event)
    },
    setCurrentSubTab(subTabKey, tabKey) {
      this.$emit('setCurrentSubTab', subTabKey, tabKey)
    },
    showSubTabContextMenu(event) {
      this.$emit('showSubTabContextMenu', event)
    },
    addNewSubTab(tabKey) {
      this.$emit('addNewSubTab', tabKey)
    },
    expandSubTabs() {
      $(this.$refs.tabLink).attr('aria-expanded', true)

      if (this.$refs.subTabs) {
        $(this.$refs.subTabs).addClass('show')
      }
    },
  },
  mounted() {
    if (this.tab.expandedByDefault || this.subTabs[this.currentTab]) {
      this.expandSubTabs()
    }
  },
}
</script>

<style lang="scss">
.nav-item__icon {
  margin-right: 4px;
  svg {
    vertical-align: -3px;
  }
  &._placeholder {
    display: none;
  }
}
.nav-link {
  position: relative;
  &:after {
    display: none !important;
  }
  &__subTabToggle {
    position: absolute;
    right: 8px;
    background: white;
    border-radius: 3px;
    line-height: 1;
    display: flex;
    width: 15px;
    height: 15px;
    justify-content: center;
    align-items: center;
    &:hover {
      background: #d5dbff;
    }
  }
  &[aria-expanded='true'] .nav-link__expandIcon._collapsed {
    display: none;
  }
  &:not([aria-expanded]) .nav-link__expandIcon._expanded {
    display: none;
  }
  &[aria-expanded='false'] .nav-link__expandIcon._expanded {
    display: none;
  }
  &__expandIcon._collapsed {
    margin-right: -2px;
    margin-bottom: -1px;
  }
}
.g-sidenav-hidden:not(.g-sidenav-show),
.g-sidenav-hide:not(.g-sidenav-show) {
  .nav-item__icon._placeholder {
    display: inline;
  }
}
</style>
